import { cn } from '@tripleten/cn';

export const cnTheme = cn('theme');
